import {IllustratedMessage} from '@common/ui/images/illustrated-message';
import {ErrorIcon} from '@common/icons/material/Error';
import {Trans} from '@common/i18n/trans';

interface Props {
  title?: string;
  description?: string;
}
export function PageErrorMessage({
  title = 'There was an issue loading this page',
  description = 'Please try again later'
}: Props) {
  return (
    <IllustratedMessage
      className="mt-40"
      image={
        <div>
          <ErrorIcon size="xl" />
        </div>
      }
      imageHeight="h-auto"
      title={<Trans message={title} />}
      description={<Trans message={description} />}
    />
  );
}
